import {combine, merge, sample, forward} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersList, initSortingsList} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    pageNumber$,
    pageNumberChanged,
    fetchDataFx,
    filtersChanged,
    Gate,
    data$,
    filters$,
    sortings$,
    sortingsChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    clearDataCacheFx,
    filtersReset,
    sortingsReset,
    filtersSubmit,
    listStateChanged,
    stateReset,
    searchChanged,
    search$,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => ({
        content: state ? state.content.concat(result.content) : result.content,
        hasNext: result.hasNext,
    }))
    .reset(sortingsChanged, filtersChanged, pageSizeChanged, Gate.close);
pageNumber$.reset(sortingsChanged, filtersChanged, pageSizeChanged, stateReset);
pageSize$.reset(stateReset);
search$.reset(Gate.close);

initFiltersList(filters$, filtersChanged, filtersReset, stateReset);
initSortingsList(sortings$, sortingsChanged, sortingsReset, stateReset);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

forward({
    from: merge([
        Gate.close,
        pageSizeChanged,
        filtersSubmit,
        filtersReset,
        sortingsChanged,
        sortingsReset,
    ]),
    to: clearDataCacheFx,
});

sample({
    clock: merge([Gate.open, listStateChanged, searchChanged]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
        search: search$,
    }),
    fn: ({pageNumber, pageSize, filters, sortings, search}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        search,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
